import { useState } from "react";

interface FilterBarProps {
  genres: string[];
  years: number[];
  activeGenre: string;
  activeYear: string;
  sort: "latest" | "hot";
  onChangeGenre: (v: string) => void;
  onChangeYear: (v: string) => void;
  onChangeSort: (v: "latest" | "hot") => void;
  onReset: () => void;
}

export default function FilterBar({
  genres,
  years,
  activeGenre,
  activeYear,
  sort,
  onChangeGenre,
  onChangeYear,
  onChangeSort,
  onReset,
}: FilterBarProps) {
  const [open, setOpen] = useState(false);
  const hasFilter = activeGenre !== "全部" || activeYear !== "全部";

  const chip = (active: boolean) =>
    `cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
      active
        ? "bg-primary-500 text-background-50"
        : "bg-background-100 text-foreground-700 hover:bg-background-200"
    }`;

  const content = (
    <div className="space-y-5">
      <div className="flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
        <span className="shrink-0 pt-1 text-sm font-medium text-foreground-500 md:w-16">类型</span>
        <div className="flex flex-wrap gap-2">
          {["全部", ...genres].map((g) => (
            <button key={g} type="button" onClick={() => onChangeGenre(g)} className={chip(activeGenre === g)}>
              {g}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
        <span className="shrink-0 pt-1 text-sm font-medium text-foreground-500 md:w-16">年份</span>
        <div className="flex flex-wrap gap-2">
          {["全部", ...years.map(String)].map((y) => (
            <button key={y} type="button" onClick={() => onChangeYear(y)} className={chip(activeYear === y)}>
              {y}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
        <span className="shrink-0 text-sm font-medium text-foreground-500 md:w-16">排序</span>
        <div className="flex gap-2">
          <button type="button" onClick={() => onChangeSort("latest")} className={chip(sort === "latest")}>
            <i className="ri-time-line mr-1"></i>最新上线
          </button>
          <button type="button" onClick={() => onChangeSort("hot")} className={chip(sort === "hot")}>
            <i className="ri-fire-line mr-1"></i>热门程度
          </button>
        </div>
        {hasFilter && (
          <button
            type="button"
            onClick={onReset}
            className="ml-auto flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700"
          >
            <i className="ri-refresh-line"></i>重置筛选
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mb-0 flex w-full cursor-pointer items-center justify-between md:hidden"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-filter-3-line"></i>筛选与排序
        </span>
        <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-xl text-foreground-500`}></i>
      </button>
      <div className={`${open ? "mt-4 block" : "hidden"} md:mt-0 md:block`}>{content}</div>
    </div>
  );
}